export default __webpack_public_path__ + "static/media/whitelabel-bg.426eb7c5.jp2";